import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DateTimeFormatPipe } from "../pipes/date-time-format.pipe";
import { HandleError, HttpErrorHandler } from "./http-error-handler.service";
import { environment } from "mds-ui/environments/environment";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class DeaneryService {
    private handleError: HandleError;
    dtformat = new DateTimeFormatPipe("en-US");
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler) {
        this.handleError = httpErrorHandler.createHandleError('DeaneryService');
    }

    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };
    getAllDeaneries(username: string): Observable<any> {
        return this._http.get<any>(
            environment.getAllDeaneriesURL +"?username=" + username+"&dateParam=" + this.dtformat.transform(new Date()), this.httpOptions)
            .pipe(catchError(this.handleError('getAllDeaneries', [])));
            
    }
}